import React, { useEffect, useState } from 'react'

import image from "../../img/something-went-wrong-illustration.png"
import { AngleDown, ArrowUpRight } from '../../svg/Icons'
import { useLocation } from 'react-router-dom';
import GoogleAnalytics from '../GA';

const ErrorPage = () => {

    const location = useLocation();
    const [data, setData] = useState('');

    const [detailsIsOpen, setDetailsIsOpen] = useState(false);
    const reportToGit= () => {
        window.location.href= "https://github.com/MyNextID/idt-plus-plus";
    }

    var dateVariable = Date().split("(")[0];

    useEffect(() => {
        if(location.state){
            if(location.state.hasOwnProperty("error")){
                if(location.state.error.hasOwnProperty("message")){
                    setData(location.state.error.message);
                }
               
            }
        }
    }, [location])

    //<main className="z-0 grow ">
    //   <div className="flex relative w-[1280px] max-w-screen-xl gap-8 flex-col px-12 py-12 text-center"></div>

    //   <div className="flex xl:w-[1280px] w-full max-w-screen-xl gap-0 sm:gap-12 px-4 sm:px-12 py-4 sm:py-12">

    return (
        <div className="flex flex-col w-full  gap-8 text-center" /*overflow-x-auto*/>        
            <h2 className='mt-8 text-primary-800 font-poppins font-bold text-[32px]'>Something went wrong</h2>

            <img
                className='m-auto'
                src={image}
                alt="Broken page"
                width="240px"
                height="240px" />

            <p className='flex self-center w-[420px] text-gray-500 text-lg font-normal text-clip'>Please <span className='contents text-primary-600 font-bold'>refresh the page </span>or check your connection. If the problem persists please report the issue.</p>

            <div className='flex self-center'>
                <button onClick={() => {reportToGit(); GoogleAnalytics("Generate MPK flow error", "btn_reportErrorToGit", "Button to report error to Git")}} className="button-primary my-2">
                    Report issue <ArrowUpRight className='size-4 text-white' />
                </button>
            </div>

            <div id="accordion-flush" data-accordion="collapse" className="w-full text-base" data-active-classes="bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-600" data-inactive-classes="text-gray-500 dark:text-gray-400">
                <h2 id="accordion-flush-heading-1">
                    <button type="button" onClick={() => setDetailsIsOpen(!detailsIsOpen)} className="mb-5 flex w-full items-center justify-between gap-3 border-b border-gray-200 py-5 font-medium text-gray-500 dark:text-gray-400 dark:border-gray-700" data-accordion-target="#accordion-flush-body-1" aria-expanded={detailsIsOpen} aria-controls="accordion-flush-body-1">
                        <span className={detailsIsOpen ? 'text-gray-900 dark:text-white ' : ''}>Technical details</span>
                        <AngleDown className={`size-4 text-gray-500 transition-transform duration-300 dark:text-gray-500 ${detailsIsOpen ? 'rotate-180 text-gray-900' : ''}`} />
                    </button>
                </h2>
                <div id="accordion-flush-body-1" className={`${detailsIsOpen ? 'block' : 'hidden'}`} aria-labelledby="accordion-flush-heading-1">
                    <div className="flex flex-col text-base font-normal text-gray-500 dark:text-gray-400">
                        {data !== ''  &&   <p>Error: {data}</p>}
                        {/*<p>Error code: 500</p>
                        <p>Request ID: 12b3cd4e5f</p>*/}
                        <p>Timestamp: {dateVariable}</p>
                    </div>
                </div>
            </div>
                
        </div>
    )
}

export default ErrorPage
